import React from "react";
import { Link } from "react-router-dom";

const InfraSection = () => {
  return (
    <div class="our-blog bg-radius-section">
      <div class="container">
        <div class="row section-row align-items-center">
          <div class="col-lg-8">
            <div class="section-title mb-0">
              <h2 class="text-anime-style-3" data-cursor="-opaque">
                Infrastructure & Equipment
              </h2>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="section-btn wow fadeInUp">
              <Link
                to="/infra-equipment"
                title="Orthopedic infrastructure Meerut"
                class="btn-default"
              >
                <span>view all infra & Equip</span>
              </Link>
            </div>
          </div>
        </div>

        <div class="infra-slider">
          <div class="swiper">
            <div
              class="swiper-wrapper"
              data-cursor-text="View"
              style={{
                maxWidth: "100vw",
                overflowX: "auto",
                gap: "1rem",
                paddingInline: "2rem",
                paddingRight: "5rem",
              }}
            >
              <div class="swiper-slide" style={{ width: "fit-content" }}>
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/1pneumatic-electric-power-system.webp"
                          alt="Pneumatic & Electric Power System"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">
                        Pneumatic & Electric Power System
                      </h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/2electric-tourniquet-system.webp"
                          alt="Electric Tourniquet System"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">Electric Tourniquet System</h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/3arthroscopy-equipment.webp"
                          alt="Arthroscopy Equipment"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">Arthroscopy Equipment</h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/4joint-replacement-equipment.webp"
                          alt="Joint Replacement Equipment"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">Joint Replacement Equipment</h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/5dedicated-orthopaedic-OT.webp"
                          alt="Orthopaedic OT"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">Dedicated Orthopaedic OT</h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/6specialized-ICU.webp"
                          alt="Specialized ICU"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">Specialized ICU</h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/7physiotherapy-rehabilitation-unit.webp"
                          alt="Physiotherapy & Rehabilitation Unit"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">
                        Physiotherapy & Rehabilitation Unit
                      </h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/8c-arm.webp"
                          alt="C-Arm"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">C-Arm</h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/9advanced-orthopaedic-robot.webp"
                          alt="World's most advanced Orthopaedic robot"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">
                        World's most advanced Orthopaedic robot
                      </h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/12DR-system-xray.webp"
                          alt="DR system for Xray"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">DR system for Xray</h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/13advanced-ventilators-monitors.webp"
                          alt="Advanced GE and Seimens Ventilators and monitors"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">
                        Advanced GE and Seimens Ventilators and monitors
                      </h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/14-high-grade-anesthesia-machines.webp"
                          alt="Highest grade Anaesthesia machines"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">
                        Highest grade Anaesthesia machines
                      </h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/15ultra-high-speed-burr.webp"
                          alt="Ultra High speed Burr"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">Ultra High speed Burr</h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/16centralised-EMR.webp"
                          alt="Centralised EMR"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">Centralised EMR</h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/17mobile-DR-system.webp"
                          alt="Mobile DR system"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">Mobile DR system</h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/18specialised-OR-table.webp"
                          alt="Specialised OR Table"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">Specialised OR Table</h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="blog-item">
                  <div class="post-featured-image">
                    <figure>
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="image-anime"
                        data-cursor-text="View"
                      >
                        <img
                          src="images/infra-equip/19joint-replacement-robot.webp"
                          alt="Joint Replacement ROBOT"
                          loading="lazy"
                        />
                      </Link>
                    </figure>
                  </div>
                  <div class="post-item-content">
                    <div class="post-item-body">
                      <h2 class="text-black">Joint Replacement ROBOT</h2>
                    </div>
                    <div class="post-item-footer">
                      <Link
                        to="/infra-equipment"
                        title="Orthopedic infrastructure Meerut"
                        class="readmore-btn"
                      >
                        explore now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfraSection;
